"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _statusModule = _interopRequireDefault(require("./status.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Type(props) {
  var data = props.data,
    onClick = props.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _statusModule["default"].common
  }, typeof data === "boolean" ? /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick && onClick,
    className: "".concat(_statusModule["default"].wrapper, " ").concat(_statusModule["default"]["_" + data], "  ").concat(_statusModule["default"][data ? "_Expired" : "_Active"])
  }, data ? "Expired" : "Active") : /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick && onClick,
    className: "".concat(_statusModule["default"].wrapper, " ").concat(_statusModule["default"]["_" + data])
  }, data === "Create" ? "New" : data));
}
var _default = Type;
exports["default"] = _default;